import { render, staticRenderFns } from "./SysAnnouncementModal.vue?vue&type=template&id=68dba137&scoped=true"
import script from "./SysAnnouncementModal.vue?vue&type=script&lang=js"
export * from "./SysAnnouncementModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68dba137",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68dba137')) {
      api.createRecord('68dba137', component.options)
    } else {
      api.reload('68dba137', component.options)
    }
    module.hot.accept("./SysAnnouncementModal.vue?vue&type=template&id=68dba137&scoped=true", function () {
      api.rerender('68dba137', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/modules/SysAnnouncementModal.vue"
export default component.exports